"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiDimentionalWeakMap = void 0;
const Which = WeakMap;
class MultiDimentionalWeakMap {
    constructor(length) {
        this.length = length;
        this.weakMap = new Which();
        this.weakMap = new Which();
    }
    get(keys) {
        if (keys.length !== this.length) {
            throw new Error("incorrect number of keys passed");
        }
        let last = this.weakMap;
        for (const key of keys) {
            last = last.get(key);
            if (!last || !(last instanceof Which))
                break;
        }
        return last;
    }
    set(keys, value) {
        if (keys.length !== this.length) {
            throw new Error("incorrect number of keys passed");
        }
        let last = this.weakMap;
        for (let i = 0; i < keys.length - 1; i++) {
            const key = keys[i];
            let val = last.get(key);
            if (!val) {
                val = new Which();
                last.set(key, val);
            }
            last = val;
        }
        const lastKey = keys[keys.length - 1];
        last.set(lastKey, value);
    }
}
exports.MultiDimentionalWeakMap = MultiDimentionalWeakMap;
